import { render, staticRenderFns } from "./ForestRSG.vue?vue&type=template&id=7d0517eb&scoped=true"
import script from "./ForestRSG.vue?vue&type=script&lang=js"
export * from "./ForestRSG.vue?vue&type=script&lang=js"
import style0 from "./ForestRSG.vue?vue&type=style&index=0&id=7d0517eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0517eb",
  null
  
)

export default component.exports